import store from "../../store";
import React,{useEffect} from "react";
import {
    addNetworkGuestsAsPlayers,
    admitTeam, createGametateFromCurrentActivityData, dataFromGameStateToCurrentActivityData,
    isTeamAdded, pruneTeams,
    shouldAdmitPerson
} from "src/containers/gameTimeTeams/gameTimeTeamsFunctions";
import {connect} from "react-redux";
import {isCurrentHost} from "src/containers/gameTime/common/gameTimeFunctions";
import {updateCurrentActivityData, updateGameState} from "../../actions/gameTime";



const GameTimeTeamsManager = (props) => {
    let stateData = store.getState();
    let admitATeam = props.admitTeam ? props.admitTeam : (item)=>admitTeam(item);
    let shouldAdmitPers = props.shouldAdmitAPerson ? props.shouldAdmitAPerson : shouldAdmitPerson;
    let admitPerson = props.admitPerson ? props.admitPerson : (item)=>addNetworkGuestsAsPlayers();
    let pruneFunc = props.pruneFunction ? props.pruneFunction : pruneTeams;
    let calcGameStateData = props.calcGameStateData ? props.calcGameStateData : dataFromGameStateToCurrentActivityData;
    let calcCurrentActivityData = props.calcCurrentActivityData ? props.calcCurrentActivityData : createGametateFromCurrentActivityData;

    //Automatically adds anyone in .teamsToAdd to the game
    let teamsTest = JSON.stringify(stateData.teamsToAdd);
    useEffect(()=>{
        if(stateData.gameTime.automaticallyAddTeams){
            //eslint-disable-next-line
            stateData.teamsToAdd.map((item)=>{
                if(!isTeamAdded(item.teamid)){
                    admitATeam(item)
                }
            });
        }
        //eslint-disable-next-line
    },[teamsTest]);

    //Automatically have users submit join requests if the setting if gameTime.automaticallyAddTeams
    let networkGuestString = JSON.stringify(stateData.networkGuests);
    useEffect(()=>{
        if( shouldAdmitPers() && Object.keys(stateData.networkGuests).length){
            admitPerson();
        }
        //eslint-disable-next-line
    },[
        stateData.webSocketData.clientid,
        stateData.gameState.gameMode,
        stateData.gameState.gamePhase,
        stateData.gameTime.automaticallyAddTeams,
        networkGuestString
    ]);

    //Prune online players who are no longer connected bassed on networkguests
    useEffect(()=>{
        pruneFunc();
        //eslint-disable-next-line
    },[networkGuestString]);

    useEffect(()=>{
        if(stateData.talkyio.talkioRoomState==='incall'){
            store.dispatch(updateGameState({gameMode:"withFriends"}));
        }
    },[stateData.talkyio.talkioRoomState]);

    //Merge Data from gameState to CurrentActivity Data if host and playing withFriends
    let gameStateData = calcGameStateData();

    let gameStateString = JSON.stringify(gameStateData);
    useEffect(()=>{
        if(stateData.gameState.gameMode==='withFriends' && isCurrentHost()) {
           store.dispatch(updateCurrentActivityData(Object.assign({}, stateData.currentActivityData, gameStateData)))
        }
        //eslint-disable-next-line
    },[gameStateString]);


    //General currentActivityData to gameState
    let gameStateFromCurr = calcCurrentActivityData();

    let gameStateFromCurrString = JSON.stringify(gameStateFromCurr);
    useEffect(()=>{

        if (!isCurrentHost() && gameStateFromCurr && typeof gameStateFromCurr==='object' && Object.keys(gameStateFromCurr).length > 0) {
            store.dispatch(updateGameState(Object.assign({}, stateData.gameState, gameStateFromCurr)))
        }
        //eslint-disable-next-line
    },[gameStateFromCurrString]);

    return <span id="gameTimeTeamsManager"> </span>
};

const mapStateToProps = (state) =>{
    return {
        gameTime:state.gameTime,
        webSocketData:state.webSocketData,
        gameState:state.gameState,
        currentActivityData:state.currentActivityData,
        networkGuests:state.networkGuests,
        teamsToAdd:state.teamsToAdd,
        talkyio:state.talkyio
    };
};

export default connect(mapStateToProps,{})(GameTimeTeamsManager);
